import { render, staticRenderFns } from "./FactureIndex.vue?vue&type=template&id=94004ac6&"
import script from "./FactureIndex.vue?vue&type=script&lang=js&"
export * from "./FactureIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94004ac6')) {
      api.createRecord('94004ac6', component.options)
    } else {
      api.reload('94004ac6', component.options)
    }
    module.hot.accept("./FactureIndex.vue?vue&type=template&id=94004ac6&", function () {
      api.rerender('94004ac6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/vente-creance/factures/FactureIndex.vue"
export default component.exports